import { useFixerContent } from '../hooks/i18n/usePageContent.js'
import { FixerSection, FixerSectionIntro } from './fixer-ui.js'

export function FixerFaqSection() {
  const c = useFixerContent()
  return (
    <FixerSection id="faq">
      <div className="fixer-stack-xl">
        <FixerSectionIntro
          channel="memory"
          kicker={c.faqIntro.number}
          title={c.faqIntro.title}
          copy={c.faqIntro.copy}
          titleId="fixer-faq-heading"
        />
        <div className="fixer-faq-list" role="list">
          {c.faqItems.map(item => (
            <details key={item.question} className="fixer-faq-item" role="listitem">
              <summary className="fixer-faq-summary">
                <span className="fixer-subheading">{item.question}</span>
                <span className="fixer-faq-chevron" aria-hidden="true" />
              </summary>
              <p className="fixer-body-sm fixer-faq-answer">{item.answer}</p>
            </details>
          ))}
        </div>
      </div>
    </FixerSection>
  )
}
